"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecommendationSummaryParser = void 0;
var _react = _interopRequireWildcard(require("react"));
var _services = require("../../../services");
var _constants = require("../../constants");
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../../../components/StyledComponents/BaseComponents");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * TODO
 * @REFACTOR - add all texts in the transformed products function
 * @RESULT no functions need to be called in the render function of the component
 */

/**
 * Represents the properties required for the RecommendationSummaryParser class.
 */

/**
 * Represents the values calculated by the RecommendationSummaryParser class.
 */

/**
 * Represents the props required for rendering the RecommendationSummary component.
 */

//--------------------------------------//
//-----------Class Definition-----------//
//--------------------------------------//

/**
 * A parser class that calculates recommendation summary values based on the provided properties.
 */
class RecommendationSummaryParser {
  /**
   * Creates an instance of RecommendationSummaryParser.
   * @param props - The properties required for the RecommendationSummaryParser.
   */
  constructor(props) {
    this.totalTermCost = void 0;
    this.totalTermCostAfterDiscount = void 0;
    this.totalUpfrontCost = void 0;
    this.discountPrices = void 0;
    this.numberOfPlans = void 0;
    this.hidePriceAfterDiscount = void 0;
    this.metadata = void 0;
    this.isCustomer = void 0;
    this.basicPlanIds = void 0;
    this.handsetUpfrontCost = void 0;
    this.products = void 0;
    this.columns = void 0;
    this.priceValue = void 0;
    this.hideDiscount = void 0;
    this.totalNumberOfPlans = void 0;
    this.transformedProducts = void 0;
    this.minimumDiscount = void 0;
    this.isSmallScreen = void 0;
    this.handsetTermCost = void 0;
    this.plan = void 0;
    this.showFullPlanName = void 0;
    this.planIdWithDifferentHeader = void 0;
    this.isPlanIdWithDifferentHeader = void 0;
    this.totalTermCost = props.totalTermCost;
    this.totalTermCostAfterDiscount = props.totalTermCostAfterDiscount;
    this.totalUpfrontCost = props.totalUpfrontCost;
    this.basicPlanIds = props.basicPlanIds;
    this.discountPrices = props.discountPrices;
    this.hidePriceAfterDiscount = props.hidePriceAfterDiscount;
    this.isCustomer = props.isCustomer;
    this.metadata = props.metadata;
    this.numberOfPlans = props.numberOfPlans;
    this.handsetUpfrontCost = props.handsetUpfrontCost;
    this.products = props.products;
    this.minimumDiscount = props.minimumDiscount;
    this.isSmallScreen = props.isSmallScreen;
    this.columns = this.calculateColumns();
    this.priceValue = this.calculatePriceValue();
    this.hideDiscount = this.calculateHideDiscount();
    this.totalNumberOfPlans = this.calculateTotalNumberOfPlans();
    this.transformedProducts = this.transformProducts();
    this.handsetTermCost = props.handsetTermCost;
    this.plan = props.plan;
    this.showFullPlanName = props.showFullPlanName;
    this.planIdWithDifferentHeader = props.planIdWithDifferentHeader;
    this.isPlanIdWithDifferentHeader = this.getIsPlanIdWithDifferentHeader();
  }

  /**
   * Gets true if plan should has different header otherwise return true.
   */
  getIsPlanIdWithDifferentHeader() {
    var _this$planIdWithDiffe;
    return (_this$planIdWithDiffe = this.planIdWithDifferentHeader) === null || _this$planIdWithDiffe === void 0 ? void 0 : _this$planIdWithDiffe.some(text => {
      var _this$plan;
      return text.includes((_this$plan = this.plan) === null || _this$plan === void 0 ? void 0 : _this$plan.variantId.split('-')[0]);
    });
  }

  /**
   * Gets the calculated recommendation summary values.
   */
  get RecommendationSummaryValues() {
    return {
      columns: this.columns,
      priceValue: this.priceValue,
      hideDiscount: this.hideDiscount,
      totalNumberOfPlans: this.totalNumberOfPlans,
      transformedProducts: this.transformedProducts
    };
  }

  /**
  * Gets the journey type.
  */
  get journeyType() {
    const {
      flags
    } = this.metadata;
    const journeyType = flags[_constants.FLAGS.BOTH_FLOW] ? _constants.FLAGS.BOTH_FLOW : flags[_constants.PRODUCT_TYPES.PLAN.toLowerCase()] ? _constants.PRODUCT_TYPES.PLAN.toLowerCase() : _constants.PRODUCT_TYPES.HANDSET.toLowerCase();
    return journeyType;
  }

  /**
   * Calculates the number of columns based on the total term cost and total upfront cost.
   * @returns The number of columns.
   */
  calculateColumns() {
    return this.totalTermCost && this.totalUpfrontCost ? 3 : 2;
  }

  /**
   * Calculates the price value based on the discount prices and upfront cost.
   * @returns The price value.
   */
  calculatePriceValue() {
    var _this$discountPrices, _this$discountPrices2;
    return ((_this$discountPrices = this.discountPrices) === null || _this$discountPrices === void 0 ? void 0 : _this$discountPrices.discountPriceValue) > 0 ? (_this$discountPrices2 = this.discountPrices) === null || _this$discountPrices2 === void 0 ? void 0 : _this$discountPrices2.discountPriceValue : this.handsetUpfrontCost;
  }

  /**
   * Calculates whether to hide the discount based on the total term cost and total term cost before discount.
   * @returns A boolean indicating whether to hide the discount.
   */
  calculateHideDiscount() {
    return this.totalTermCost === this.totalTermCostAfterDiscount;
  }

  /**
   * Calculates the total number of plans based on the metadata flags and number of plans.
   * @returns The total number of plans.
   */
  calculateTotalNumberOfPlans() {
    var _this$metadata, _this$metadata$flags;
    return (_this$metadata = this.metadata) !== null && _this$metadata !== void 0 && (_this$metadata$flags = _this$metadata.flags) !== null && _this$metadata$flags !== void 0 && _this$metadata$flags[_constants.FLAGS.IS_CUSTOMER] ? this.numberOfPlans : this.numberOfPlans + 1;
  }

  /**
   * Transforms the products into a format that can be used by the recommendation summary section.
   * @returns The transformed products.
   */

  transformProducts() {
    var _this$products;
    return (_this$products = this.products) === null || _this$products === void 0 ? void 0 : _this$products.map(product => {
      var _this$basicPlanIds, _product$additional;
      const isBasicPlan = (_this$basicPlanIds = this.basicPlanIds) === null || _this$basicPlanIds === void 0 ? void 0 : _this$basicPlanIds.some(text => {
        var _product$variantId;
        return text.includes(product === null || product === void 0 ? void 0 : (_product$variantId = product.variantId) === null || _product$variantId === void 0 ? void 0 : _product$variantId.split('-')[0]);
      });
      return {
        ...product,
        isBasicPlan: isBasicPlan,
        discount: Math.round(100 * (1 - ((product === null || product === void 0 ? void 0 : product.termCost) + (product === null || product === void 0 ? void 0 : (_product$additional = product.additional) === null || _product$additional === void 0 ? void 0 : _product$additional.totalCost)) / (this.calculateTotalNumberOfPlans() * (product === null || product === void 0 ? void 0 : product.termCost)))),
        termCostDisplay: this.productTermCostAfterDiscountByProduct(product),
        costSubText: this.productCostSubText(product),
        additionalPlanText: this.calculateAdditionalPlanText(isBasicPlan, product)
      };
    });
  }

  /**
   * Gets the product upfront cost.
   * @returns The product upfront cost.
   */
  get productUpfrontCost() {
    return this.discountPrices.discountPercentage ? /*#__PURE__*/_react.default.createElement("del", null, _services.locale.formatPrice(this.handsetUpfrontCost)) : _services.locale.formatPrice(this.handsetUpfrontCost);
  }

  /**
   * Returns the product term cost before discount based on a given product object.
   * @returns The product term cost.
   */
  productTermCostAfterDiscountByProduct(product) {
    return _services.locale.formatPrice(product.termCostAfterDiscount ? product.termCostAfterDiscount : product.termCost);
  }

  /**
   * Returns the product cost subtext based on a given product object.
   * @param product - The SummaryProduct object.
   * @returns The product cost subtext.
   */
  productCostSubText(product) {
    return product.productType === _constants.PRODUCT_TYPES.HANDSET ? `${_services.locale.localeString('Recommendation.upTo')} ${product.termDuration} ${_services.locale.localeString('Recommendation.installments')}` : !this.hideDiscount && product.termCostAfterDiscount && _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: product.termDuration,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(product.termCost),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    });
  }

  /**
   * Returns the additional plan text based on the given product object.
   * @param isBasicPlan - A boolean indicating whether the product is a basic plan.
   * @param product - The SummaryProduct object.
   * @returns The additional plan text.
   */
  calculateAdditionalPlanText(isBasicPlan, product) {
    var _product$additional2;
    return `${this.totalNumberOfPlans - 1} x ${isBasicPlan ? _services.locale.localeString(`Recommendation.Additional.basicPlan`) : _services.locale.localeString(`Recommendation.Additional.${(_product$additional2 = product.additional) === null || _product$additional2 === void 0 ? void 0 : _product$additional2.productType}`)}`;
  }

  /**
   * Calculates the total term cost based on  totalTermCostAfterDiscount being defined
   * @returns The total term cost.
   */
  get totalTermCostText() {
    var _this$handsetTermCost;
    const totalTermCost = this.totalTermCostAfterDiscount ? this.totalTermCostAfterDiscount : this.totalTermCost;
    return _services.locale.formatPrice(totalTermCost + ((_this$handsetTermCost = this.handsetTermCost) !== null && _this$handsetTermCost !== void 0 ? _this$handsetTermCost : 0));
  }

  /**
   * Gets the wrapper component for the recommendation summary section.
   * @returns The wrapper component reference. Always Fragment.
   */
  get WrapperComponent() {
    return _react.Fragment;
  }

  /**
  * Gets the component for the recommendation summary section.
  * @returns The recommendation summary component depending on journeyType or null.
  */
  getRecommendationSummaryComponent(props) {
    var _this$discountPrices3;
    const {
      breakPoints,
      testId,
      flexBasis,
      isCustomer,
      flexDirection
    } = props;
    const {
      hideDiscount,
      priceValue,
      totalNumberOfPlans,
      transformedProducts
    } = this.RecommendationSummaryValues;
    const WrapperComponent = this === null || this === void 0 ? void 0 : this.WrapperComponent;
    return /*#__PURE__*/_react.default.createElement(_BaseComponents.BorderWrapper, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.PageWrapper, {
      gap: 16
    }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: breakPoints.sm ? 3 : 1,
      weight: 2,
      dataAttributes: {
        'data-testid': `order-summary-title-${testId}`
      },
      text: _services.locale.localeString('Recommendation.Summary')
    })), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null)), !breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `products-column-title-${testId}`
      }
    }, _services.locale.localeString('Recommendation.Products'))), !!this.totalUpfrontCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('RelationshipOffer.Upfront'), " ")), !!this.totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints,
      alignItems: "right"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `prices-column-title-${testId}`
      }
    }, _services.locale.localeString('RelationshipOffer.Monthly')))), breakPoints.mdAndAbove && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), transformedProducts.map((product, index) => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
        flexDirection: flexDirection,
        justifyContent: "space-between"
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
        size: 1,
        weight: 3,
        dataAttributes: {
          'data-test-id': `plan-section-title-${testId}`
        },
        text: _services.locale.localeString(`Recommendation.${product.productType}`)
      })), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
        flexDirection: flexDirection,
        justifyContent: "space-between"
      }, /*#__PURE__*/_react.default.createElement(WrapperComponent, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
        flexBasis: flexBasis
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          bottom: breakPoints.sm ? 3 : 0
        }
      }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
        flexBasis: flexBasis
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          bottom: 2
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-test-id': `products-column-title-${testId}`
        }
      }, _services.locale.localeString('Recommendation.Products'), ' '))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-test-id': `plan-name-${testId}`
        }
      }, product.name))), !!this.handsetUpfrontCost && product.productType === _constants.PRODUCT_TYPES.HANDSET && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
        breakPoints: breakPoints
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          bottom: 2
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('RelationshipOffer.Upfront')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
        breakPoints: breakPoints
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          bottom: 2
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, this.productUpfrontCost)))), !!this.totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
        breakPoints: breakPoints,
        alignItems: "right"
      }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
        breakPoints: breakPoints
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          bottom: 2
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-test-id': `prices-column-title-${testId}`
        }
      }, _services.locale.localeString('RelationshipOffer.Monthly')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.MainTextWrapper, {
        "data-test-id": `price-after-discount-order-summary-${testId}`,
        breakPoints: breakPoints
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        weight: breakPoints.sm ? 3 : 2,
        noMargin: true
      }, product.termCostDisplay), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        noMargin: true,
        size: 1,
        weight: breakPoints.sm ? 3 : 2
      }, "/", _services.locale.localeString('Recommendation.month'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-test-id': `plan-price-order-summary-${testId}`
        },
        size: 1
      }, product.costSubText)))), product.additional && !(isCustomer && this.numberOfPlans === 1) && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
        flexDirection: flexDirection,
        justifyContent: "space-between"
      }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
        flexBasis: flexBasis
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          bottom: breakPoints.sm ? 3 : 0,
          top: breakPoints.sm ? 5 : 0
        }
      }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
        flexBasis: flexBasis
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-test-id': `products-column-title-${testId}`
        }
      }, _services.locale.localeString('Recommendation.Products'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          top: breakPoints.sm ? 2 : 0
        }
      }, /*#__PURE__*/_react.default.createElement(_BaseComponents.TextAndPillWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-test-id': `additional-plan-${testId}`
        },
        noMargin: true
      }, product.additionalPlanText))))), !!this.totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
        breakPoints: breakPoints,
        alignItems: "right"
      }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
        breakPoints: breakPoints
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          bottom: 2
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-test-id': `prices-column-title-${testId}`
        }
      }, _services.locale.localeString('RelationshipOffer.Monthly')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.MainTextWrapper, {
        "data-test-id": `additional-price-after-discount-summary-${testId}`,
        breakPoints: breakPoints
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        noMargin: true,
        weight: breakPoints.sm ? 3 : 2
      }, _services.locale.formatPrice(product.additional.totalCostAfterDiscount)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        noMargin: true,
        size: 1,
        weight: breakPoints.sm ? 3 : 2
      }, "/", _services.locale.localeString('Recommendation.month'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
        dataAttributes: {
          'data-test-id': `additional-price-order-summary-${testId}`
        },
        size: 1
      }, !hideDiscount && _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
        amount: product.additional.termDuration,
        unit: _services.locale.localeString('Recommendation.month'),
        price: _services.locale.formatPrice(product.additional.totalCost),
        pluralUnit: _services.locale.localeString('Recommendation.Month')
      })))));
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(WrapperComponent, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis,
      padding: {
        bottom: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 2,
      noMargin: true,
      dataAttributes: {
        'data-test-id': `total-plan-number-${testId}`
      },
      text: totalNumberOfPlans > 1 && !this.totalUpfrontCost ? _services.locale.localeString('Recommendation.TotalNumOfPlans', {
        amount: totalNumberOfPlans
      }) : _services.locale.localeString('Recommendation.Total'),
      weight: 3
    })), /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!((_this$discountPrices3 = this.discountPrices) !== null && _this$discountPrices3 !== void 0 && _this$discountPrices3.discountPercentage) && /*#__PURE__*/_react.default.createElement(_BaseComponents.OnlineDiscountPill, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      noMargin: true,
      justify: "center",
      size: 1,
      weight: 2
    }, /*#__PURE__*/_react.default.createElement("span", null, `${Math.round(this.discountPrices.discountPercentage)}%`), ' ', _services.locale.localeString('Recommendation.onlineDiscount'))), !!priceValue && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 2,
      noMargin: true,
      text: _services.locale.formatPrice(priceValue),
      weight: 3
    }))), !!this.totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints,
      alignItems: "right"
    }, /*#__PURE__*/_react.default.createElement(_BaseComponents.MainTextWrapper, {
      "data-test-id": `total-price-after-discount-${testId}`,
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 2,
      noMargin: true,
      text: this.totalTermCostText,
      weight: 3
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      noMargin: true,
      text: `/${_services.locale.localeString('Recommendation.month')}`
    })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `total-price-${testId}`
      },
      size: breakPoints.sm ? 2 : 1
    }, !hideDiscount && this.totalTermCostAfterDiscount ? _services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: this.plan.termDuration,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(this.totalTermCost),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    }) : ''), !!this.numberOfPlans && !(isCustomer && this.numberOfPlans === 1) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      appearance: "secondary",
      size: breakPoints.sm ? 3 : 2,
      noMargin: true,
      dataAttributes: {
        'data-test-id': `price-per-plan-${testId}`
      },
      text: `${_services.locale.formatPrice(this.totalTermCostAfterDiscount / totalNumberOfPlans)}c/${_services.locale.localeString('Recommendation.plan')}`,
      weight: breakPoints.sm ? 2 : 3
    }))))));
  }
}
exports.RecommendationSummaryParser = RecommendationSummaryParser;